import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Order } from './order';

@Injectable()
export class OrderService implements Resolve<any> {
  public rows: any;
  public onOrderListChanged: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onOrderListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllOrders()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllOrders(): Promise<Order[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/orders`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        this.onOrderListChanged.next(this.rows);
        resolve(this.rows);
      }, reject);
    });
  }

  getServicedOrders(): Promise<Order[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/orders/serviced`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        resolve(this.rows);
      }, reject);
    });
  }

  getOrder(orderId): Promise<Order> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/orders/${orderId}`, { headers }).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }


  createOrder(order): Promise<void> {
    delete order.id;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/orders`, order, { headers }).subscribe((response: any) => {
        this.getAllOrders();
        resolve();
      }, reject);
    });
  }

  updateOrder(order): Promise<void> {
    delete order.ownedBy;
    order.endpoint = order.endpoint.id;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/orders/${order.id}`, order, { headers }).subscribe((response: any) => {
        this.getAllOrders();
        resolve();
      }, reject);
    });
  }

  updateOrderPaid(order, paid): Promise<void> {
    delete order.ownedBy;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/orders/${order.id}/paid`, {paid: paid}, { headers }).subscribe((response: any) => {
        this.getAllOrders();
        resolve();
      }, reject);
    });
  }
}
